var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-upgrading"},[_c('div',{staticClass:"card"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"alt":"logo"}}),_c('div',{staticClass:"title"},[_vm._v("服务正在升级中...")]),_c('div',{staticClass:"desc"},[_vm._v("我们正在进行系统升级维护，给您带来不便敬请谅解。")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }